import dJSON from 'dirty-json';

const moduleSelector = '.category-cards--grid';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      const inner = query.querySelector('.category-cards__inner');

      data.forEach((item) => {
        inner.insertAdjacentHTML('beforeend', /* html */ `
          <div class="category-card">
            <img class="category-card__image" src="${item.background}">
            <div class="category-card__content">
              <h3 class="category-card__title">${item.title}</h3>
              <p class="category-card__description">${item.text}</p>
              <a class="category-card__button btn-custom secondary" href="${item.button_link}">${item.button_text}</a>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
